import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import { ConfirmSubscriptionForm } from "../forms/confirm-subscription-form";


export const ConfirmSubscriptionModal: React.FC<{ name: string; email: string; onDecision: (confirmed: boolean) => void }> = ({ name, email, onDecision }) => {
    const [show, setShow] = useState(true);

    const handleClose = useCallback((confirmed: boolean) => {
        setShow(false);
        onDecision(confirmed);
    }, [setShow]);

    return (
        <Modal size="sm" show={show} onHide={() => handleClose(false)} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Bekræft tilmelding</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ConfirmSubscriptionForm name={name} email={email} close={handleClose} />
            </Modal.Body>
        </Modal>
    );
};
